import type {
  ApiResponse,
  CustomFieldDefinition,
  CustomFieldType,
} from '@packages/shared-types';

import { apiClient } from '@/services/apiClient';

export type CreateCustomFieldDefinitionPayload = {
  name: string;
  key: string;
  type: CustomFieldType;
  required?: boolean;
  options?: string[];
  isSystem?: boolean;
  sortOrder?: number;
  categoryId?: string | null;
};

export type UpdateCustomFieldDefinitionPayload = {
  name?: string;
  key?: string;
  type?: CustomFieldType;
  required?: boolean;
  options?: string[];
  sortOrder?: number;
  categoryId?: string | null;
};

export async function listCustomFieldDefinitions(
  categoryId?: string | null,
): Promise<CustomFieldDefinition[]> {
  const params: Record<string, string> = {};
  if (categoryId) params.categoryId = categoryId;
  const response = await apiClient.get<
    ApiResponse<CustomFieldDefinition[]>
  >('/api/custom-field-definitions', { params });
  return response.data.data;
}

export async function getCustomFieldDefinition(
  id: string,
): Promise<CustomFieldDefinition> {
  const response = await apiClient.get<
    ApiResponse<CustomFieldDefinition>
  >(`/api/custom-field-definitions/${id}`);
  return response.data.data;
}

export async function createCustomFieldDefinition(
  payload: CreateCustomFieldDefinitionPayload,
): Promise<CustomFieldDefinition> {
  const response = await apiClient.post<
    ApiResponse<CustomFieldDefinition>
  >('/api/custom-field-definitions', payload);
  return response.data.data;
}

export async function updateCustomFieldDefinition(
  id: string,
  payload: UpdateCustomFieldDefinitionPayload,
): Promise<CustomFieldDefinition> {
  const response = await apiClient.put<
    ApiResponse<CustomFieldDefinition>
  >(`/api/custom-field-definitions/${id}`, payload);
  return response.data.data;
}

export async function deleteCustomFieldDefinition(
  id: string,
): Promise<void> {
  await apiClient.delete(`/api/custom-field-definitions/${id}`);
}

export async function getItemCustomFieldValues(
  itemId: string,
): Promise<Record<string, string | number>> {
  const response = await apiClient.get<
    ApiResponse<Record<string, string | number>>
  >(`/api/items/${itemId}/custom-fields`);
  return response.data.data;
}

export async function upsertItemCustomFieldValues(
  itemId: string,
  values: Record<string, string | number>,
): Promise<Record<string, string | number>> {
  const response = await apiClient.put<
    ApiResponse<Record<string, string | number>>
  >(`/api/items/${itemId}/custom-fields`, { values });
  return response.data.data;
}
